
import { Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import CustomerCard from '@/views/customerManage/template/CustomerCard.vue'
import LabelFilters from '@/views/customerManage/template/LabelFilters.vue'
import GroupFilters from '@/views/customerManage/template/GroupFilters.vue'
import LevelFilters from '@/views/customerManage/template/LevelFilters.vue'
import {
  CustomerListDto,
  deleteMerchants,
  getMerchantsList,
  getMerchantsApplyListNum, checkUserBindMobile, TagListDto, GroupListDto, LevelListDto
} from '@/api/customerManage'
import { toBindMobile } from '@/utils/h5ToApp'
import { MessageUnReadMixin } from '@/mixins/messageUnRead'

@Component({
  name: 'CustomerManage',
  components: {CustomerCard, LabelFilters, GroupFilters, LevelFilters}
})
export default class CustomerManage extends Mixins(MessageUnReadMixin) {
  @Getter companyId!: string
  groupId = ''
  customerList: CustomerListDto[] = []
  applyCount = 0
  refreshing = false
  loading = false
  finished = false
  params = {
    companyId: '',
    pageIndex: 1,
    pageSize: 10,
    isPage: true,
    levelId: '',
    tagId: '',
    groupId: '',
    merchantsType: ['1', '3']
  }
  // 折叠面板
  collapseActive = []

  levelName = '客户级别'
  labelName = '客户标签'
  GroupName = '客户分组'

  mounted () {
    this.refreshPage()
  }

  created () {
    this.params.companyId = this.companyId
    this.getList()
    this.getMessageNo()
  }

  getList () {
    getMerchantsList(this.params).then((res) => {
      let records = res.data.records.map(item => {
        return {
          ...item,
          isOpen: false // 控制折叠板展开收起，默认false收起
        }
      })
      this.customerList = records
      if (this.customerList.length >= res.data.totalRecords) {
        this.finished = true
      } else {
        this.finished = false
      }
    }).finally(() => {
      this.refreshing = false
    })
  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getList()
    // 重置折叠面板
    this.collapseActive = []
  }

  /**
   * 上拉加载更多
   */
  onLoad () {
    this.params.pageIndex++
    this.loading = true
    getMerchantsList(this.params).then((res) => {
      this.loading = false
      let records = res.data.records.map(item => {
        return {
          ...item,
          isOpen: false // 控制折叠板展开收起，默认false收起
        }
      })
      this.customerList = this.customerList.concat(records)
      if (this.customerList.length >= res.data.totalRecords) {
        this.finished = true
      }
    }).finally(() => {
      this.refreshing = false
    })
  }

  beforeClose ({position, instance}) {
    switch (position) {
      case 'cell':
        break
      case 'outside':
        instance.close()
        break
    }
  }

  delData (id: string) {
    // if (!this.$action('delete')) {
    //   return false
    // }
    this.$confirmDialog.show({
      okText: '确认',
      cancelText: '取消',
      tips: '确定删除吗？',
      onOk: () => {
        return this.delFunc(id)
      },
    })
  }

  delFunc (id: string) {
    const params = {
      companyId: this.companyId,
      merchantsId: id
    }
    deleteMerchants(params).then((res) => {
      this.$toast.success('删除成功')
      this.getList()
    }).catch(() => {
    })
  }

  /**
   * 打开详情页
   * @param e
   * @param id 关联id
   * @param merchantsId 客户编号
   */
  toDetail (e: string, id: string, merchantsId: string) {
    if (!this.$action('customerDetail')) {
      return false
    }
    if (e === 'cell') {
      this.$router.push({
        path: '/customerDetail',
        query: {
          relationId: id,
          merchantsId: merchantsId
        }
      })
    }
  }

  toBuyCar () {
    // if (!this.$action('toBuyCar')) {
    //   return false
    // }
    this.$router.push('/buyCar')
  }

  addCustomer () {
    // if (!this.$action('addCustomer')) {
    //   return false
    // }
    this.$router.push('/addCustomer')
  }

  toSearch () {
    this.$router.push({
      path: '/searchShop',
      query: {
        tagId: this.params.tagId,
        groupId: this.params.groupId,
        levelId: this.params.levelId
      }
    })
  }

  toApply () {
    if (!this.$action('customerApply')) {
      return false
    }
    this.$router.push({
      path: '/customerApply'
    })
  }

  showLabels () {
    const options: { companyId: string, tags: TagListDto[] } = {
          companyId: this.companyId,
          tags: this.params.tagId ? [{tagId: this.params.tagId}] : []
        }
    ;(this.$refs.labelFilters as any).show(options)
  }

  showGroup () {
    const options: { companyId: string, groupId: string } = {
          companyId: this.companyId,
          groupId: this.params.groupId
        }
    ;(this.$refs.groupFilters as any).show(options)
  }

  showLevel () {
    const options: { companyId: string, levelId: string } = {
          companyId: this.companyId,
          levelId: this.params.levelId
        }
    ;(this.$refs.levelFilters as any).show(options)
  }

  getTagId (data: TagListDto[]) {
    this.params.tagId = data && data.length > 0 ? data[0].tagId : ''
    this.labelName = data && data.length > 0 ? data[0].tagName : '客户标签'
    this.getList()
  }

  getGroupId (id: string, data: GroupListDto) {
    this.params.groupId = id
    this.GroupName = data.groupName || '客户分组'
    this.getList()
  }

  getLevelId (id: string, data: LevelListDto) {
    this.params.levelId = id
    this.levelName = data.levelName || '客户级别'
    this.getList()
  }

  /**
   * 当点击底部导航，页面切换时，原生调用h5接口，重新获取未读消息条数
   */
  refreshPage () {
    this.$bridge.registerHandler('refreshPage', (data: string, responseCallback) => {
      this.getMessageNo()
    })
  }

  toApplyQuota (type: number) {
    if (!this.$action('applyQuota' + type)) {
      return false
    }
    if (type === 1) {
      //    判断是否绑定手机号
      checkUserBindMobile().then((res) => {
        if (res.code === '000000') {
          this.jumpToApplyQuota(type)
        } else if (res.code === '000002') {
          // 前端跳绑定手机流程
          const data = {
            path: 'applyQuota', // 客户选择页面路由名称
            applyType: 1 // 选择客户类型
          }
          toBindMobile(data)
        }
      })
    } else {
      this.jumpToApplyQuota(type)
    }
  }

  /**
   * 跳转到客户选择页面
   * @param type 1.未出额（去出额）2.已出额（去借款）3.已放款（去还款）
   */
  jumpToApplyQuota (type: number) {
    this.$router.push({
      path: '/applyQuota',
      query: {
        applyType: String(type)
      }
    })
  }
}
